/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: Date | string; output: Date; }
  Long: { input: number; output: number; }
  UUID: { input: string; output: string; }
};

export type MainColour = {
  __typename?: 'MainColour';
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByDisplayName?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isInactive: Scalars['Boolean']['output'];
  mainColourName?: Maybe<Scalars['String']['output']>;
  mainColourNumber: Scalars['Long']['output'];
};

export type MasterColour = {
  __typename?: 'MasterColour';
  colourGroupNumbers: Array<Scalars['Long']['output']>;
  colourTypeName?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['UUID']['output']>;
  createdByDisplayName?: Maybe<Scalars['String']['output']>;
  createdDate?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  mainColourName?: Maybe<Scalars['String']['output']>;
  masterColourCode?: Maybe<Scalars['String']['output']>;
  masterColourHexCode: Scalars['String']['output'];
  masterColourName: Scalars['String']['output'];
  masterColourNumber: Scalars['Long']['output'];
  standardColourName?: Maybe<Scalars['String']['output']>;
};

export type MasterColourConnection = {
  __typename?: 'MasterColourConnection';
  edges?: Maybe<Array<MasterColourEdge>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount: Scalars['Int']['output'];
};

export type MasterColourEdge = {
  __typename?: 'MasterColourEdge';
  cursor: Scalars['String']['output'];
  node: MasterColour;
};

export type Mutation = {
  __typename?: 'Mutation';
  saveRequestedColour: RequestedColourResponse;
};


export type MutationSaveRequestedColourArgs = {
  requestedColourInput: RequestedColourInput;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  getAllExistingColours?: Maybe<MasterColourConnection>;
  getMainColours: Array<Maybe<MainColour>>;
  getRequestedColours: Array<Maybe<RequestedColour>>;
  getStandardAndMainColour: StandardAndMainColour;
};


export type QueryGetAllExistingColoursArgs = {
  generalQuery?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  pagination: PaginationInput;
  sortBy?: InputMaybe<SortByInput>;
};


export type QueryGetMainColoursArgs = {
  sortBy?: InputMaybe<SortByInput>;
};


export type QueryGetStandardAndMainColourArgs = {
  hexCode: Scalars['String']['input'];
};

export enum RequestStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type RequestedColour = {
  __typename?: 'RequestedColour';
  colourCode?: Maybe<Scalars['String']['output']>;
  colourName: Scalars['String']['output'];
  colourTypeName: Scalars['String']['output'];
  colourTypeNumber: Scalars['Long']['output'];
  createdBy: Scalars['UUID']['output'];
  createdByDisplayName: Scalars['String']['output'];
  createdDate: Scalars['Date']['output'];
  hexCode: Scalars['String']['output'];
  mainColourName?: Maybe<Scalars['String']['output']>;
  mainColourNumber?: Maybe<Scalars['Long']['output']>;
  publicId?: Maybe<Scalars['UUID']['output']>;
  standardColourName?: Maybe<Scalars['String']['output']>;
  standardColourNumber?: Maybe<Scalars['Long']['output']>;
};

export type RequestedColourInput = {
  changedBy?: InputMaybe<Scalars['UUID']['input']>;
  colourCode?: InputMaybe<Scalars['String']['input']>;
  colourName: Scalars['String']['input'];
  colourTypeNumber: Scalars['Long']['input'];
  createdBy: Scalars['UUID']['input'];
  hexCode: Scalars['String']['input'];
  mainColourNumber?: InputMaybe<Scalars['Long']['input']>;
  publicId?: InputMaybe<Scalars['UUID']['input']>;
  standardColourNumber?: InputMaybe<Scalars['Long']['input']>;
  status?: InputMaybe<RequestStatus>;
};

export type RequestedColourResponse = {
  __typename?: 'RequestedColourResponse';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SortByInput = {
  sortByAttribute?: InputMaybe<Scalars['String']['input']>;
  sortByDirection?: InputMaybe<Scalars['String']['input']>;
};

export type StandardAndMainColour = {
  __typename?: 'StandardAndMainColour';
  mainColourName: Scalars['String']['output'];
  mainColourNumber: Scalars['Long']['output'];
  standardColourName: Scalars['String']['output'];
  standardColourNumber: Scalars['Long']['output'];
};

export type SaveRequestedColourMutationVariables = Exact<{
  requestedColourInput: RequestedColourInput;
}>;


export type SaveRequestedColourMutation = { __typename?: 'Mutation', saveRequestedColour: { __typename?: 'RequestedColourResponse', message?: string | null, status?: string | null } };

export type GetStandardAndMainColourQueryVariables = Exact<{
  hexCode: Scalars['String']['input'];
}>;


export type GetStandardAndMainColourQuery = { __typename?: 'Query', getStandardAndMainColour: { __typename?: 'StandardAndMainColour', mainColourNumber: number, mainColourName: string, standardColourNumber: number, standardColourName: string } };


export const SaveRequestedColourDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveRequestedColour"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestedColourInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestedColourInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveRequestedColour"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestedColourInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestedColourInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SaveRequestedColourMutation, SaveRequestedColourMutationVariables>;
export const GetStandardAndMainColourDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStandardAndMainColour"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hexCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getStandardAndMainColour"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hexCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hexCode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mainColourNumber"}},{"kind":"Field","name":{"kind":"Name","value":"mainColourName"}},{"kind":"Field","name":{"kind":"Name","value":"standardColourNumber"}},{"kind":"Field","name":{"kind":"Name","value":"standardColourName"}}]}}]}}]} as unknown as DocumentNode<GetStandardAndMainColourQuery, GetStandardAndMainColourQueryVariables>;